module.exports = __webpack_public_path__ + "static/medals-image-95b3a038e0e64ca311fecfbacf198e80.jpg";